import React, { useContext } from 'react';

import { Context } from '@store/store';

import { StyledSearchButton } from './search-button.styles';
import SearchIcon from '@icons/search-icon';

const SearchButton = ({ isMobile }) => {
  const [, dispatch] = useContext(Context);

  return (
    <StyledSearchButton
      data-ignore-click-outside="sidebar"
      onClick={() => {
        dispatch({ type: 'TOGGLE_SEARCH_SIDEBAR' });
      }}
      title="Поиск в тексте"
    >
      <SearchIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} />
    </StyledSearchButton>
  );
};

export default SearchButton;
